import { memo, useCallback, useEffect, useState } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import classes from "./styles.module.scss";

import { Typography } from "@components/atoms/typography";
import { convertToTwoDigits } from "@utils";
import type { IVisitTimerProps } from "@components/organisms/videoVisit";

export const VisitTimer = memo(function VisitTimer({ date }: IVisitTimerProps) {
  const { t } = useTranslation("common");

  const calculateTimeLeft = useCallback(() => {
    const difference = Date.now() - +new Date(date);

    if (difference >= 0) {
      return {
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return {};
  }, [date]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });
  const formatTimeLeft = () => {
    return Object.keys(timeLeft).length > 0
      ? `${convertToTwoDigits(timeLeft.hours)}:${convertToTwoDigits(
          timeLeft.minutes,
        )}:${convertToTwoDigits(timeLeft.seconds)}`
      : "- - -";
  };

  return (
    <div className={clsx(classes.timer)}>
      <Typography
        variant={"description1"}
        className={clsx(classes.timer__time)}
      >
        {formatTimeLeft()}
      </Typography>{" "}
      <Typography
        fontSize={"md"}
        fontWeight={"semi-bold"}
        color={"primary-text"}
      >
        {t("live")}
      </Typography>
      <span className={clsx(classes.timer__dot)} />
    </div>
  );
});
